module.exports = __webpack_public_path__ + "img/list-image-reserve.1c40b8bf.svg";